import AdminWrapper from "@/admin/components/addmin-wrapper/AdminWrapper";
import ServiceRequestComp from "@/admin/components/service-request-comp/ServiceRequestComp";
import DataNotFound from "@/components/data-not-found/DataNotFound";
import Spinner from "@/components/spinner/Spinner";
import useGetApiReq from "@/hooks/useGetApiReq";
import { useEffect, useState } from "react";

import {
    Table,
    TableBody,
    TableHead,
    TableHeader,
    TableRow,
} from "@/components/ui/table";
import { Chart } from "./charts/chart";
import { Chart1 } from "./charts/chart1";
import { Chart2 } from "./charts/chart2";
import { Chart3 } from "./charts/chart3";

const Dashboard = () => {
  const { res, fetchData, isLoading } = useGetApiReq();

  const [allRequests, setAllRequests] = useState([]);

  const getRecentRequests = async () => {
    fetchData("/admin/get-recent-requests");
  };

  useEffect(() => {
    getRecentRequests();
  }, []);

  useEffect(() => {
    if (res?.status === 200 || res?.status === 201) {
      console.log("requests res", res);
      setAllRequests(res?.data?.requests);
    }
  }, [res]);

  return (
    <AdminWrapper>
      <div>
        <div className="grid grid-cols-2 gap-5 mt-5">
          <Chart />
          <Chart1 />
        </div>

        <div className="grid grid-cols-2 gap-5 mt-5">
          <Chart2 />
          <Chart3 />
        </div>

        <div className="section-heading-container mt-10">
          <h1 className="section-heading">Recent Requests</h1>
        </div>
        <Table className="mt-4 glass-header !border-white !border-2">
          <TableHeader>
            <TableRow className="text-lg">
              <TableHead>Client Name</TableHead>
              <TableHead>Client Phone No</TableHead>
              <TableHead>Service Name</TableHead>
              <TableHead>Service Cost</TableHead>
              <TableHead>Status</TableHead>
              <TableHead>Date</TableHead>
              <TableHead>Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {allRequests?.map((request) => (
              <ServiceRequestComp
                key={request._id}
                serviceRequest={request}
                getServiceRequests={getRecentRequests}
              />
            ))}
          </TableBody>
        </Table>
        {allRequests.length === 0 && isLoading && <Spinner size={30} />}

        {allRequests.length === 0 && !isLoading && (
          <DataNotFound name={"Requests"} />
        )}
      </div>
    </AdminWrapper>
  );
};

export default Dashboard;
